import { render, staticRenderFns } from "./ComboBoxMenuObject.vue?vue&type=template&id=c8a0fb56&scoped=true&"
import script from "./ComboBoxMenuObject.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxMenuObject.vue?vue&type=script&lang=ts&"
import style0 from "./ComboBoxMenuObject.vue?vue&type=style&index=0&id=c8a0fb56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a0fb56",
  null
  
)

export default component.exports